import { useEffect, useState } from 'react';
import './style.css';
import { http_request } from '../../../libs/connection';
import { API_ADDR, BASE_ROUTE } from '../../../config';
import { NavLink, useNavigate } from 'react-router-dom';
import { Button, FormControl, Toast, ToastContainer } from 'react-bootstrap';
import { isObject } from 'lodash';
import Progress from '../../../components/progress';


export default function PurchaseVendorMaterialShortages() {
    const navigate = useNavigate();
    const [is_loading, setLoadingStatus] = useState(false);
    const [sheetData, setSheetData] = useState(null);
    const [file, setFile] = useState(null);
    const [success_toast_show, showSuccessToast] = useState(false);
    const [success_message, setSuccessMessage] = useState('');
    const [error_toast_show, showErrorToast] = useState(false);
    const [error_message, setErrorMessage] = useState('');
    const user_info = JSON.parse(localStorage.getItem('user_info_company') || '{}');


    useEffect(()=>{
        loadSheet();
    }, []);
    

    function loadSheet(){
        if(!user_info?.cu_no) return;
        setLoadingStatus(true);
        setSheetData(null);
        return new Promise(resolve=>{
            let params = {
                cu_no: user_info.cu_no
            };
            http_request('/purchaseOrder/getExcel', 'POST', params).then(res=>{
                resolve();
                setLoadingStatus(false);
                if(res?.success === false && res?.message === "查无档案"){
                    setSheetData(false);
                }else if(res.success){
                    let pack = res?.data?.excel;
                    if(isObject(pack) && Object.values(pack).length > 0){
                        setSheetData(Object.values(pack)[0]);
                    }else{
                        setErrorMessage('档案格式错误');
                        showErrorToast(true);
                        setSheetData(false);
                    }
                }else{
                    setErrorMessage('档案读取失败');
                    showErrorToast(true);
                    setSheetData(false);
                }
            });
                
        });
    }

    return <div id="page-purchase-vendor-material-shortages" className={`page`}>
        <Progress show={is_loading} />
        <ToastContainer 
            position='middle-bottom'
            style={{ zIndex: 1056 }}
            >
            <Toast 
                show={success_toast_show} 
                onClose={()=>{ showSuccessToast(false); }}
                delay={2000}
                autohide
                bg="success"
                className='text-white'
            >
                <Toast.Header>
                    <strong className="me-auto">已完成</strong>
                </Toast.Header>
                <Toast.Body>{success_message}</Toast.Body>
            </Toast>
        </ToastContainer>
        <ToastContainer
            position='middle-bottom'
            style={{ zIndex: 1056 }}
        >
            <Toast 
                show={error_toast_show} 
                onClose={()=>{ showErrorToast(false); }}
                delay={3000}
                autohide
                bg="danger"
                className='text-white'
            >
                <Toast.Header>
                    <strong className="me-auto">上传失败</strong>
                </Toast.Header>
                <Toast.Body>{error_message}</Toast.Body>
            </Toast>
        </ToastContainer>
        <div className={`container p-2 d-flex flex-column h-100 overflow-y-auto`}>
            {
                sheetData !== null && <div className='p-4 mt-3 card'>
                    {
                        sheetData === false && <EmptyTip />
                    }
                    {
                        sheetData && <Sheet rawData={sheetData} />
                    }
                </div>
            }
        </div>
    </div>
}

function EmptyTip({ companyName }){
    return <div className='d-flex flex-column flex-sm-row align-items-center justify-content-center p-5'>
        <div>暂无欠料表</div>
    </div>
}

function Sheet({ rawData }){
    const [sheet, setSheet] = useState(null);

    useEffect(()=>{
        parserawData();
    }, [rawData]);

    function parserawData() {
        if(!isObject(rawData)) return;
        let sheet = {
            head: [],
            body: [],
        };
        for(let r in rawData){
            let row = rawData[r];
            let parsedRow = [];
            for(let c in row){
                let cell = row[c];
                cell.style = styleParser(cell);
                parsedRow.push(cell);
            }
            sheet.body.push(parsedRow);
        }
        setSheet(sheet);

        function styleParser(cell){
            let style = {};
            if(cell.bg_color) style.backgroundColor = cell.bg_color;
            if(cell.font_color) style.color = cell.font_color;
            return style;
        }
    }

    return sheet && <div className='overflow-x-auto'>
        <table>
            <tbody>
                {
                    sheet.body.map((row, r)=><tr key={r}>
                        {
                            row.map((cell, c)=>{
                                let is_link = r >= 2 && c == 0;
                                let link = `${BASE_ROUTE}/purchase/detail/${cell.value}`;
                                return <td key={c} style={{
                                    ...cell.style,
                                    textDecoration: is_link ? 'underline' : 'none',
                                }}>
                                    {
                                        is_link ? <NavLink to={link} target="_blank">{cell.value}</NavLink> : cell.value
                                    }
                                </td>
                            })
                        }
                    </tr>)
                }
            </tbody>
        </table>
    </div>
}